module.exports = __webpack_public_path__ + "static/img/文字.951739d9.png";